import { render } from "./App.vue?vue&type=template&id=4c61e2be"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4c61e2be&lang=css"
script.render = render

export default script